module.exports = __webpack_public_path__ + "img/RORBPJS40024.53547dbb.png";